<template>
  <div class="footer-p">
    <div class="main">
      <div>
        <div class="kfhotline">
          <div class="kelx">
            <i class="iconfont icon-kefu"></i>
            <span class="xr">客服热线</span>
          </div>
          <div>187-4993-8350</div>
        </div>
      </div>
      <div class="safety">
        <div>
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?spm=a21bo.2017.1997523009.44.5af911d91G6eF5&recordcode=31011202008703"
          >
            <img
              src="@/assets/images/home/plice.png"
              alt=""
              style="width: 15px; vertical-align: middle"
            />
            沪公网安备：31011202008703
          </a>
          &nbsp; 工信部ICP备案号：          <a
            target="_blank"
            href="https://beian.miit.gov.cn/#/Integrated/index"
          >沪ICP备17051338号-3 </a> &nbsp;
          <!-- <a target="_blank" href="/legalStatement"> 法律声明 </a> -->
          <a href="javascript:void(0)"> 法律声明 </a>
        </div>
        <div class="firm">
          &copy;2022 上海佳配汽车零部件有限公司版权所有
        </div>
      </div>
    </div>
    <div class="h30"></div>
  </div>
</template>

<script>
export default {
  name: 'footer-p',
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {},
  computed: {},
  watch: {}
}
</script>
<style lang="less" scoped>
.footer-p {
  // border-top: 1px solid #e2e2e2;
  margin-top: 27px;
  .main {
    width: 1200px;
    height: 80px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    letter-spacing: 0.5px;
    padding: 20px 0;
    font-size: 12px;
    .kfhotline {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 80px;
      padding-right: 45px;
      border-right: 1px solid #e2e2e2;
      .kelx {
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #434343;
        .icon-kefu {
          font-size: 16px;
        }
        .xr {
          width: 52px;
          height: 12px;
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 0px;
          color: #434343;
          letter-spacing: 2px;
          margin-left: 5px;
        }
      }
    }
    a {
      color: #787878;
      font-size: 12px;
    }
    a:hover {
      color: #e90d0d;
    }
  }
  .h30 {
    height: 30px;
  }
  .safety {
    display: flex;
    flex-direction: column;
    margin-left: 79px;
    justify-content: center;
    align-items: center;
    color: #787878;
    .firm {
      margin-top: 5px;
    }
  }
}
</style>
